import React, { useState } from "react";
import { useGoogleSyncStore } from "../../stores/googleSyncStore";
import { useCalendarStore } from "../../stores/calendarStore";
import { addIcsSource, removeSyncSource, type SyncSourceInfo } from "../../lib/googleApi";
import { SyncSourceList } from "./SyncSourceList";

export function IcsFeedSection() {
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const syncSources = useGoogleSyncStore((s) => s.syncSources);
  const fetchStatus = useGoogleSyncStore((s) => s.fetchStatus);
  const fetchCalendars = useCalendarStore((s) => s.fetch);

  const icsSources = syncSources.filter((s) => s.type === "ics");

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const result = await addIcsSource(url, name || undefined);
      setMessage(`Added "${result.calendarName}"`);
      setUrl("");
      setName("");
      await fetchStatus();
      await fetchCalendars();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to add ICS feed");
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (source: SyncSourceInfo) => {
    if (!confirm(`Remove "${source.calendarSummary}"? The calendar and all its events will be deleted.`)) {
      return;
    }
    try {
      await removeSyncSource(source.id);
      await fetchStatus();
      await fetchCalendars();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to remove");
    }
  };

  return (
    <div className="settings-section">
      <p className="settings-eyebrow">ICS Feeds</p>
      <p className="settings-desc">
        Subscribe to external calendars via ICS URL (Google, Nextcloud, any .ics feed).
      </p>

      <SyncSourceList
        label="Active feeds"
        sources={icsSources}
        fallbackName="ICS Feed"
        onRemove={handleRemove}
      />

      <form onSubmit={handleAdd}>
        <div className="form-group">
          <label className="label" htmlFor="ics-url">Feed URL</label>
          <input
            id="ics-url"
            className="input"
            type="url"
            placeholder="https://calendar.google.com/...basic.ics"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label className="label" htmlFor="ics-name">Name (optional)</label>
          <input
            id="ics-name"
            className="input"
            type="text"
            placeholder="Auto-detected from feed"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        {error && <p className="error-text">{error}</p>}
        {message && <p className="success-text">{message}</p>}

        <div className="form-actions" style={{ justifyContent: "flex-start" }}>
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? "Adding..." : "Add Feed"}
          </button>
        </div>
      </form>
    </div>
  );
}
